/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} User_Detail_Gw_Per_GameInputs */



/**
* | output |
* | --- |
* | "GW per game: {value}" |
*
* @param {User_Detail_Gw_Per_GameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_gw_per_game = /** @type {((inputs: User_Detail_Gw_Per_GameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Gw_Per_GameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`GW par partie : ${i?.value}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`GW por partida: ${i?.value}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`GW por partida: ${i?.value}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`GW per partita: ${i?.value}`)
	return /** @type {LocalizedString} */ (`GW per game: ${i?.value}`)
});